module.exports = __webpack_public_path__ + "img/tpc-24.811fd1ec.webp";